export const meKey = ['me'] as const

export const assetKeys = {
  all: ['assets'] as const,
  details: () => [...assetKeys.all, 'detail'] as const,
  detail: (id: string | null | undefined) => [...assetKeys.details(), id] as const
}

export const qk = {
  user: {
    listInfinity: (params?: any) => ['users', 'listInfinity', params] as const
  },
  materialGroup: {
    listInfinity: (params?: any) => ['materialGroup', 'listInfinity', params] as const
  },
  unitSmall: {
    listInfinity: (params?: any) => ['unitSmall', 'listInfinity', params] as const
  },
  unitPurchase: {
    listInfinity: (params?: any) => ['unitPurchase', 'listInfinity', params] as const
  },
  supplier: {
    listInfinity: (params?: any) => ['supplier', 'listInfinity', params] as const
  },
  product: {
    listInfinity: (params?: any) => ['product', 'listInfinity', params] as const
  },
  rawMaterial: {
    list: (params?: any) => ['rawMaterial', 'list', params] as const,
    detail: (id: string) => ['rawMaterial', 'detail', id] as const
  }
}
